export default __webpack_public_path__ + "static/media/Headshot-1.453f5267.png";